import axiosInstance from "@/lib/axiosInstance";
import { TransformStore } from "@/types/trainerTypes";
import { create } from "zustand";

let isInitialLoad = true;

// Create store without persist middleware to avoid hydration issues
export const useTransformStore = create<TransformStore>((set, get) => ({
    transforms: null,
    singleTransform: null,
    isLoading: false,
    error: null,

    getAllTransforms: async () => {
        // Prevent multiple calls if data is already loaded or loading
        if (!isInitialLoad || get().isLoading) {
            return;
        }

        try {
            set({ isLoading: true, error: null });
            const res = await axiosInstance.get(`/reviews/populated`);
            if (!res.data) throw new Error('No data received');
            
            const transforms = res.data.data.filter((item: any) => 
                (item.beforeImage || item.afterImage || 
                 item.beforeStatus?.image || item.afterStatus?.image)
            );
            
            set({ transforms, isLoading: false });
            isInitialLoad = false;
        } catch (error: any) {
            console.error('Error fetching transforms:', error);
            set({ 
                isLoading: false, 
                error: error.response?.data?.message || error.message || 'Failed to fetch transforms'
            });
        }
    },

    getTransformById: async (id: string) => {
        try {
            set({ isLoading: true, error: null });
            const res = await axiosInstance.get(`/reviews/${id}/populated`);
            if (!res.data) throw new Error('No data received');
            
            set({ singleTransform: res.data.data, isLoading: false });
        } catch (error: any) {
            console.error('Error fetching transform:', error);
            set({ 
                isLoading: false, 
                error: error.response?.data?.message || error.message || 'Failed to fetch transform'
            });
        }
    },

    resetStore: () => {
        set({ transforms: null, singleTransform: null, error: null, isLoading: false });
        isInitialLoad = true;
    }
}));
